import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import Typography from 'Components/UI/Typography';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 0,
  },
  icon: {},
  text: {
    paddingLeft: theme.spacing(1),
  },
});

const Institution = ({
  className,
  classes,
  resource,
  TypographyProps,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <AccountBalanceIcon
        className={classes.icon}
        color={'primary'}
      />
      <Typography
        className={classes.text}
        noWrap
        {...TypographyProps}
      >
        {resource.attr('name') || resource.attr('institutionName')}
      </Typography>
    </Box>
  );
};

Institution.defaultProps = {
  className: '',
  TypographyProps: {},
};

Institution.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  TypographyProps: PropTypes.object,
};

export default withStyles(styles)(Institution);
